<app-input-wrapper
  [label]="label"
  [required]="required"
  [alt]="alt"
  [errorMessage]="errorMessage"
  [touched]="touched"
  [leftIcon]="leftIcon"
  [rightIcon]="rightIcon"
  [valueLabel]="valueLabel"
>
  <ng-container *ngIf="type === 'textarea'; else textInput">
    <textarea
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [value]="value"
      (input)="handleInputChange($event)"
      (blur)="onTouched()"
      class="p-inputtextarea p-component"
      [ngClass]="{
        'input-with-left-icon': leftIcon,
        'input-with-right-icon': rightIcon,
        'input-readonly': readonly,
        'resize-none': !resize
      }"
    ></textarea>
  </ng-container>
  <ng-template #textInput>
    <input
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [value]="value"
      (input)="handleInputChange($event)"
      (blur)="onTouched()"
      class="p-inputtext p-component"
      [ngClass]="{
        'input-with-left-icon': leftIcon,
        'input-with-right-icon': rightIcon,
        'input-readonly': readonly
      }"
    />
  </ng-template>
</app-input-wrapper>
